import React from 'react'

const EmptyDay = () => (
  <div className="bg-white my-8 p-8 shadow lg:hidden">
    <p className="m-0 font-bold text-11 uppercase">No Events</p>
  </div>
)

export default EmptyDay
